export default {
    su2SurveyId: null,
    su2SurveyToken: null,
  };